export class UpdateAzureSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAzureSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
